import * as React from "react"
import { useRecoilValue } from "recoil"
import { SDKContext } from "../../../context/SDKContext"
import { StyledHandIcon } from "./buttons-main-screen.styled"
import { brandingSelector } from "../../../recoil/atoms/room"
import { IconButton } from "../../common/buttons"
import { HandIconProps } from "./buttons-main-screen.interface"
import { viewDependingLayoutAtom } from "../../../recoil/atoms/view"
import { addHitAreaStyle } from "../../../util/styleUtils"

export const HandIcon: React.FC<HandIconProps> = ({
  showIcon,
  isMobile,
  isHeartIcon,
  localUserProperties,
  changeSizeIconDependingHeightVideo
}) => {
  const meetingClient = React.useContext(SDKContext)
  const { isLandscape } = useRecoilValue(viewDependingLayoutAtom)
  const roomStyles = useRecoilValue(brandingSelector)

  const handleRaiseHand = React.useCallback(
    e => {
      e.stopPropagation()
      e.preventDefault()
      meetingClient?.sendHandRaised(!localUserProperties?.handUp)
      
      // submit event only when user raise the hand 
      if(!localUserProperties?.handUp) {
        meetingClient?.userEventLog.submitRaiseHandButtonEvent()
      }
    },
    [localUserProperties?.handUp, meetingClient]
  )

  const raiseHandColor = React.useMemo<string>(() => {
    if (localUserProperties?.handUp) {
      return "#FFD701"
    }
    return "rgba(0, 0, 0, 0.2)"
  }, [localUserProperties?.handUp])

  const stylesDesktopHandIcon: React.CSSProperties = React.useMemo(() => {
    return {
      marginBottom: "10px"
    }
  }, [])

  if (!showIcon) {
    return null
  }

  return (
    <>
      {isMobile ? (
        <IconButton
          width="1.9rem"
          height={
            isLandscape
              ? !isHeartIcon
                ? "2.2rem"
                : "1.8rem"
              : changeSizeIconDependingHeightVideo &&
                `${changeSizeIconDependingHeightVideo(27, 32)}px`
          }
          isMobile={isMobile}
          onClick={handleRaiseHand}
          marginBottom={isHeartIcon && !isMobile && "7px"}
          alignItems={isMobile && !isHeartIcon ? "besline" : "center"}
          marginTop={isMobile && !isHeartIcon && "8px"}
          {...addHitAreaStyle({ left: 5, right: 5, top: 0, bottom: 0 })}
        >
          <StyledHandIcon
            roomStyles={roomStyles}
            size="1.9em"
            width="1.9rem"
            issmall={"true"}
            value={localUserProperties?.handUp}
            color={raiseHandColor}
            className="icon-ios"
            style={{ transform: "translate(0%, 0%)" }}
          />
        </IconButton>
      ) : (
        <StyledHandIcon
          roomStyles={roomStyles}
          size="1.9em"
          width="1.9rem"
          onClick={handleRaiseHand}
          value={localUserProperties?.handUp}
          color={raiseHandColor}
          className="icon-ios"
          style={stylesDesktopHandIcon}
        />
      )}
    </>
  )
}
